var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBolivia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 17.5536 39.56 15.2101 38.756 13.0436L20 12.174L1.24398 13.0435C0.44 15.2101 0 17.5536 0 20C0 22.4464 0.44 24.79 1.24398 26.9565L20 27.8261L38.756 26.9566C39.56 24.79 40 22.4464 40 20Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 40.0001C28.5993 40.0001 35.9302 34.5726 38.756 26.9565H1.24402C4.06988 34.5726 11.4007 40.0001 20 40.0001Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.24402 13.0436H38.7561C35.9302 5.42756 28.5993 6.10352e-05 20 6.10352e-05C11.4007 6.10352e-05 4.06988 5.42756 1.24402 13.0436V13.0436Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolivia);
export default __webpack_public_path__ + "static/media/bolivia.99dcf23b2d6cf03c601529994aeb4ba5.svg";
export { ForwardRef as ReactComponent };